/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a week model
 * @export
 * @interface CreateWeekModelRequest
 */
export interface CreateWeekModelRequest {
    /**
     * Name of week model
     * @type {string}
     * @memberof CreateWeekModelRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the CreateWeekModelRequest interface.
 */
export function instanceOfCreateWeekModelRequest(value: object): value is CreateWeekModelRequest {
    return true;
}

export function CreateWeekModelRequestFromJSON(json: any): CreateWeekModelRequest {
    return CreateWeekModelRequestFromJSONTyped(json, false);
}

export function CreateWeekModelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWeekModelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CreateWeekModelRequestToJSON(json: any): CreateWeekModelRequest {
    return CreateWeekModelRequestToJSONTyped(json, false);
}

export function CreateWeekModelRequestToJSONTyped(value?: CreateWeekModelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

